/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Subscription_Price_MonthlyInputs */

const en_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const ar_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const de_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const es_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const fr_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const it_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const ja_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const ko_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const pt_br_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const ru_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const th_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const tr_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const zh_cn_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/月`)
};

const zh_tw_subscription_price_monthly = /** @type {(inputs: Subscription_Price_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/月`)
};

/**
* | output |
* | --- |
* | "{price}/month" |
*
* @param {Subscription_Price_MonthlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_price_monthly = /** @type {((inputs: Subscription_Price_MonthlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Price_MonthlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_price_monthly(inputs)
	if (locale === "ar") return ar_subscription_price_monthly(inputs)
	if (locale === "de") return de_subscription_price_monthly(inputs)
	if (locale === "es") return es_subscription_price_monthly(inputs)
	if (locale === "fr") return fr_subscription_price_monthly(inputs)
	if (locale === "it") return it_subscription_price_monthly(inputs)
	if (locale === "ja") return ja_subscription_price_monthly(inputs)
	if (locale === "ko") return ko_subscription_price_monthly(inputs)
	if (locale === "pt_br") return pt_br_subscription_price_monthly(inputs)
	if (locale === "ru") return ru_subscription_price_monthly(inputs)
	if (locale === "th") return th_subscription_price_monthly(inputs)
	if (locale === "tr") return tr_subscription_price_monthly(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_price_monthly(inputs)
	return zh_tw_subscription_price_monthly(inputs)
});